import { useState } from 'react';

type SetSelectedChartDate = (date: string) => void;

interface UseMobileChartResetReturn {
  resetMobileChartCount: number;
  setSelectedChartDateWithReset: SetSelectedChartDate;
}

// Native period charts reset via this counter (not selectedDate) so swiping doesn't fight the FlatList; external date changes (calendar/arrows) bump it to rebuild the chart.
export const useMobileChartReset = (setSelectedChartDate: SetSelectedChartDate): UseMobileChartResetReturn => {
  const [resetMobileChartCount, setResetMobileChartCount] = useState(0);

  const setSelectedChartDateWithReset: SetSelectedChartDate = (date) => {
    setSelectedChartDate(date);
    setResetMobileChartCount((count) => count + 1);
  };

  return { resetMobileChartCount, setSelectedChartDateWithReset };
};
